<template>
    <div class="sdjz2Footer">
        <div class="footer-top">
            <div class="left">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/shandongjiazheng/footer-logo2.png" alt="">
            </div>
            <div class="right">
                <span @click="goPage(1)">政府监管</span><span @click="goPage(2)">居家上门证服务办理</span>
            </div>
        </div>
        <!-- <div class="bottom">
            <span>版权所有：伟东国信</span>    <span>技术支持：伟东云教育</span> 
        </div> -->
        <saas-nsr-footer :textColor="'#363636'" :bgColor="'#EAEAEA'"/>
    </div>
</template>
<script>
export default {
    name:'sdjz2Footer',
    data(){
        return{

        }
    },
    methods:{
        goPage(type){
            const host = window.location.host;
            if(type == 1){
                window.open(`https://${host}/screen?type=2`)
            }else if(type == 2){
                window.open(`https://${host}/doorToDoorApproval`)
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.sdjz2Footer{
    width 100%
    height auto
    background #EEEEEE
    .footer-top{
        width 1200px
        height 132px
        margin 0 auto
        display flex
        justify-content space-between
        align-items center
        .left{
            width 350px
            img{
                width 350px
            }    
        }
        .right{
            
            span{
                margin-left 48px
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #4D4D4D;
                line-height: 22px;
                cursor pointer
            }
            .line{
                margin-left 30px
                margin-right 30px
            }
        }

    }
    .bottom{
        width 100%
        height 52px
        text-align center
        line-height 52px
        background rgba(219, 219, 219, .5)
        
        span{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4D4D4D;
            &:nth-child(2){
                margin-left 20px    
            }
        }
    }
}
</style>